import { useMemo } from "react";
import { useSelector } from "react-redux";

import { resolveTagField } from "@/lib/visitorTagField";

/**
 * Tag-Feld-Konfiguration des Standorts (Bezeichnung, Beschreibung,
 * Einfach-/Mehrfachauswahl, Pflicht).
 *
 * Die Settings aller Standorte des Kunden liegen unter
 * `company.data.visitor_module_settings` (geladen via
 * `GET_VISITOR_MODULE_SETTINGS_REQUEST`). Ohne Treffer gelten die Defaults, die
 * Maske sieht dann aus wie bisher.
 */
export function useVisitorTagField(locationId) {
  const settingsByLocation = useSelector(
    (state) => state.company.data.visitor_module_settings,
  );

  return useMemo(
    () =>
      resolveTagField(
        locationId != null ? settingsByLocation?.[String(locationId)] : null,
      ),
    [locationId, settingsByLocation],
  );
}
